export default __webpack_public_path__ + "static/legibility-dont-fd4091f7a462b38cef288b1a6f454eb6.png";